module.exports = __webpack_public_path__ + "media/images/active-agents-249b015a57d5677720d17045f928e98b.png";